import { Input } from '~/components/ui/input'
import { useFieldContext } from '~/hooks/form-hooks'
import { Field, type FieldProps } from './field'

type TextFieldProps = React.ComponentProps<typeof Input> &
  Omit<FieldProps, 'children' | 'error'> & {
    transformValue?: (value: string) => string
  }

export function TextField({
  label,
  id,
  optional,
  className,
  transformValue,
  onChange,
  ...props
}: TextFieldProps) {
  const field = useFieldContext<string>()

  const errorMessage = (field.state.meta.errors as { message: string }[]).at(0)?.message

  return (
    <Field
      label={label}
      id={id}
      optional={optional}
      required={props.required}
      error={errorMessage}
      className={className}
    >
      <Input
        {...props}
        id={field.name}
        name={field.name}
        onBlur={field.handleBlur}
        onChange={(e) => {
          const value = transformValue ? transformValue(e.target.value) : e.target.value
          field.handleChange(value)
          onChange?.(e)
        }}
        aria-invalid={errorMessage !== undefined}
        value={field.state.value}
      />
    </Field>
  )
}
